import { Reveal } from "@/components/site/Motion";
import { Label } from "@/components/site/Blocks";

const AWARDS = [
  ["a2", "Awarded Best SEO Agency 2026 — EU Business News, Irish Enterprise Awards 2026"],
  ["a3", "Awarded Best Digital Marketing Agency 2026 – Ireland — Corporate Vision, Global Business Awards 2026"],
  ["a4", "Awarded Best SEO Agency 2026 — EU Business News, Irish Enterprise Awards 2026"],
  ["a5", "CorporateLiveWire Innovation & Excellence Awards 2026 Winner"],
  ["a6", "Winner — Marketing & Advertising Firm of the Year 2025, Global Publishing Media Group"],
  ["a7", "Winner — Most Dedicated Marketing Agency 2025, Corporate Vision Magazine"],
  ["a8", "Digital Marketing Agency of the Year 2024 — Corporate Vision Magazine UK"],
];

export const Awards = () => (
  <section data-testid="awards-section" className="bg-[#FAFAFC] pb-0 pt-20 sm:pt-24">
    <div className="wrap">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <Reveal><Label>Recognition</Label></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display text-3xl font-medium leading-tight text-slate-900 sm:text-4xl lg:text-5xl">
              Award-winning <span className="font-serif-i text-gradient-dark">search specialists.</span>
            </h2>
          </Reveal>
        </div>
      </div>
      <div data-testid="awards-grid" className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 lg:grid-cols-7">
        {AWARDS.map(([f, alt], i) => (
          <Reveal key={f} delay={i * 0.05} y={16}
            className="group flex aspect-square items-center justify-center rounded-3xl border border-slate-200 bg-white p-4 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:border-violet-300 hover:shadow-[0_30px_60px_-30px_rgba(76,29,149,0.35)]"
            data-testid={`award-${i}`}>
            <img src={`/awards/${f}.webp`} alt={alt} loading="lazy" className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-105" />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
